module.exports = __webpack_public_path__ + "img/ZTOBUHaveOrder_01.13b3aafc.jpg";